import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useConnectFacebookAccount } from '../../../../../api/connectFacebookAccount'
import { getFacebookToken } from '../../../../../api/facebookSsoToken'
import { PLATFORMS } from '../../../../../models'
import { useAppStore } from 'Stores/appStoreModuleFed'

import { ConnectionOptions } from '../../../../common/ConnectionOptions/ConnectionOptions'
import { PlatformConnectOption } from '../../../../common/ConnectionOptions/PlatformConnectOption'

export const ConnectMetaAccount = ({
  submitPlatformId,
  onClose,
}: {
  submitPlatformId: (id: number) => void
  onClose: () => void
}) => {
  const [token, setToken] = useState<string>('')
  const { t } = useTranslation('PMPlatforms')
  const { showToaster } = useAppStore()

  useConnectFacebookAccount({
    token: token,
    config: {
      enabled: !!token,
      onSuccess: (data) => {
        if (data.id) submitPlatformId(data.id)
      },
    },
  })

  const onConnectPlatform = async () => {
    try {
      const fbToken = await getFacebookToken()

      if (fbToken) {
        setToken(fbToken)
      }
    } catch {
      showToaster(t('meta-connection-wizard.sso-fail'), 'failure')
    }
  }

  return (
    <ConnectionOptions onClose={onClose}>
      <PlatformConnectOption
        platform={PLATFORMS.META}
        title={t('meta-connection-wizard.step-1-title')}
        description={t('meta-connection-wizard.step-1-explainer')}
        onClick={onConnectPlatform}
      />
    </ConnectionOptions>
  )
}
